// extracted by mini-css-extract-plugin
export default {"divider":"VZcI_IBBfJA2XbQzuu2B","marginBottom":"PToFfCH0IliXz6cs2NWx"};